export default function BannerProductTable(props) {
  const { productList, handleSelectProduct } = props;

  return (
    <>
      <div className="mt-[12px] h-[20rem] block whitespace-nowrap overflow-auto">
        <table className="w-full text-center">
          <thead className="top-0 sticky">
            <tr className="border border-[#dddddd]" key={0}>
              <th className="font-bold w-12 p-2 bg-[#f2f2f4] border border-[#dddddd]">
                선택
              </th>
              <th className="font-bold p-2 bg-[#f2f2f4] border border-[#dddddd]">
                번호
              </th>
              <th className="font-bold p-2 bg-[#f2f2f4] border border-[#dddddd]">
                카테고리
              </th>
              <th className="font-bold p-2 bg-[#f2f2f4] border border-[#dddddd]">
                상품 그룹명
              </th>
              <th className="font-bold p-2 bg-[#f2f2f4] border border-[#dddddd]">
                정상 판매가
              </th>
              <th className="font-bold p-2 bg-[#f2f2f4] border border-[#dddddd]">
                현재 재고수량
              </th>
            </tr>
          </thead>

          <tbody>
            {productList?.length > 0 ? (
              <>
                {productList
                  ?.map((data, index) => {
                    return {
                      index,
                      data,
                    };
                  })
                  .map((item) => {
                    const { data, index } = item;
                    return (
                      <tr key={index}>
                        <td className="p-1.5 border border-[#dddddd]">
                          <input
                            type="radio"
                            name="prod"
                            className="w-4 h-4 cursor-pointer accent-primary-blue my-auto"
                            onChange={() =>
                              handleSelectProduct(
                                data?.productGroup?.id,
                                data?.productGroup?.name
                              )
                            }
                            // checked={selectedProducts?.includes(data?.id)}
                          />
                        </td>

                        <td className="p-1.5 border border-[#dddddd]">
                          {productList?.length - index}
                        </td>
                        <td className="p-1.5 border border-[#dddddd]">
                          {data?.productGroup?.productGroupCategory?.name}
                        </td>
                        <td className="p-1.5 border border-[#dddddd]">
                          {data?.name}
                        </td>
                        <td className="p-1.5 border border-[#dddddd]">
                          {parseInt(data?.price).toLocaleString("ko-KR")}
                        </td>
                        <td className="p-1.5 border border-[#dddddd]">
                          {data?.productStockHistory?.reduce(
                            (accumulator, object) => {
                              return accumulator + object.currentStock;
                            },
                            0
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </>
            ) : (
              <>
                {Array.from({ length: 5 }).map(() => (
                  <tr className="h-8">
                    <td className="p-2 border border-[#dddddd]">
                      <input
                        type="radio"
                        name="prod"
                        className="w-4 h-4 cursor-pointer accent-primary-blue my-auto"
                      />
                    </td>
                    <td className="p-2 border border-[#dddddd]"></td>
                    <td className="p-2 border border-[#dddddd]"></td>
                    <td className="p-2 border border-[#dddddd]"></td>
                    <td className="p-2 border border-[#dddddd]"></td>
                    <td className="p-2 border border-[#dddddd]"></td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
